import React from "react"
import { verifyFiles } from "frontend/utils/upload"

import { v4 as uuidv4 } from "uuid"
import styles from "./LocalUpload.module.css"
import { FILE_TYPES } from "./constants"
import { logUploadFlowEvent, t } from "frontend/utils"
import scribdAuthorize from "app/assets/javascripts/scribd/scribd_oauth"

let selectionMethod = ""

const LocalUpload = ({ onFileSelection, inputRef, setError }) => {
  const handleLocalFileSelection = (e) => {
    setError("")

    const fileArray = Array.from(e.target.files)

    logUploadFlowEvent("files_selected", {
      number_of_files: fileArray.length,
      selection_method: selectionMethod,
    })

    const files = fileArray.map((file) => {
      logUploadFlowEvent("file_queued", { file_source: "local" })

      return {
        filename: file.name,
        originalFile: file,
        uploadId: uuidv4(),
        size: file.size,
      }
    })

    try {
      verifyFiles(files)
    } catch (e) {
      logUploadFlowEvent("validation_error")

      setError(e.message)
      return
    }

    onFileSelection(files)
  }

  const handleDrop = (e) => {
    if (!window.upload_config.logged_in) {
      e.preventDefault()
      return scribdAuthorize({ from_source: window.location.pathname })
    }
    selectionMethod = "drop"
  }

  const handleClick = (e) => {
    if (!window.upload_config.logged_in) {
      e.preventDefault()
      return scribdAuthorize({ from_source: window.location.pathname })
    }
    selectionMethod = "select"
  }

  return (
    <div>
      <label htmlFor="local-upload" hidden>
        {t("upload.selection.prompt")}
      </label>
      <input
        onChange={handleLocalFileSelection}
        onDrop={handleDrop}
        onClick={handleClick}
        ref={inputRef}
        id="local-upload"
        tabIndex={-1}
        type="file"
        accept={FILE_TYPES.join(",")}
        className={styles.dropzone}
        multiple
      />
    </div>
  )
}

LocalUpload.defaultProps = {
  onFileSelection: () => {},
  setError: () => {},
}

export default LocalUpload
